import { render, staticRenderFns } from "./BatchPreviewPage.vue?vue&type=template&id=639064c8&scoped=true"
import script from "./BatchPreviewPage.vue?vue&type=script&lang=js"
export * from "./BatchPreviewPage.vue?vue&type=script&lang=js"
import style0 from "./BatchPreviewPage.vue?vue&type=style&index=0&id=639064c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639064c8",
  null
  
)

export default component.exports